import abstractModel from "../../core/MercatelyModel";

const resource = `${ENV.DEAL_ENGINE_BASE_URL}/funnels/`;

const model = abstractModel(resource);

model.getWithAutomations = async (params) => {
  const newResource = `${ENV.DEAL_ENGINE_BASE_URL}/funnels/${params.web_id}/with_automations`;

  return model.get({}, { path: newResource });
};

export default model;
